import React from 'react';
import styles from './AdminMobileCateList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH3FontSize, registerGap1, registerGap2 } from 'routes/adminMobile/constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

const AdminMobileCateList = ({categories}) => {
    if (!categories || categories.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    // 카테고리 갯수 테스트 데이터
    const cateCnt = 20;

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {categories && categories.map((category, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap2}>
                            <FlexChild>
                                <HorizontalFlex gap={registerGap1}>
                                    <FlexChild>
                                        <P size={pageEH3FontSize}>{category.categoryName}</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <P size={pageEH3FontSize}>
                                            {cateCnt ? cateCnt.toLocaleString() : 0} 개 상품
                                        </P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={registerGap1}>
                                    <FlexChild>
                                        <div className={styles.modifyBtn}>수정</div>
                                    </FlexChild>
                                    <FlexChild>
                                        <div className={styles.deleteBtn}>삭제</div>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
        </VerticalFlex>
    );
};

export default AdminMobileCateList;